import { PyodideInterface } from 'pyodide';
import type { PyProxy } from 'pyodide/ffi';

import { PythonBlockResult } from './types';
import { pythonTypeConverter } from './python';

export function isPyProxy(obj: any) {
  return (
    obj !== undefined &&
    typeof obj === 'object' &&
    'toJs' in obj &&
    'destroy' in obj &&
    typeof obj.toJs === 'function'
  );
}

export function convertPythonResult(
  pyodide: PyodideInterface,
  result: any,
  namespace?: any,
): PythonBlockResult {
  if (result === undefined) {
    return undefined;
  }

  const pyProxies: PyProxy[] = [];
  try {
    // Run the converter in the same namespace as the code execution if provided
    const conversionContext = namespace !== undefined ? { globals: namespace } : undefined;
    const pyConvertFunction = pyodide.runPython(pythonTypeConverter, conversionContext);
    pyProxies.push(pyConvertFunction);

    const pyData = pyConvertFunction!(result);
    pyProxies.push(pyData);

    if (pyData.raw_py_class !== undefined) {
      console.log(`python result is of type "${pyData.raw_py_class}"`);
    }

    if (pyData?.type === 'table') {
      const { type, fields, rows: rows_str } = pyData;
      return {
        type,
        fields,
        rows: JSON.parse(rows_str),
      };
    }
    return pyData;
  } finally {
    for (const pyProxy of pyProxies) {
      if (isPyProxy(pyProxy)) {
        pyProxy.destroy();
      }
    }
  }
}
